/* tslint:disable */
/* eslint-disable */
/**
 * CarePlatform User Preferences API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    UpdateUserLocaleRequest,
    UpdateUserLocaleRequestFromJSON,
    UpdateUserLocaleRequestToJSON,
    UpdateUserVideoBackgroundRequest,
    UpdateUserVideoBackgroundRequestFromJSON,
    UpdateUserVideoBackgroundRequestToJSON,
    UserPreferencesResponse,
    UserPreferencesResponseFromJSON,
    UserPreferencesResponseToJSON,
} from '../models';

export interface GetPreferencesRequest {
    userId: string;
}

export interface UpdateLocaleRequest {
    userId: string;
    updateUserLocaleRequest: UpdateUserLocaleRequest;
}

export interface UpdateVideoBackgroundRequest {
    userId: string;
    updateUserVideoBackgroundRequest: UpdateUserVideoBackgroundRequest;
}

/**
 * 
 */
export class UserPreferencesApi extends runtime.BaseAPI {

    /**
     * Get all user preferences for a specific user.
     * Get all user-preferences by userId
     */
    async getPreferencesRaw(requestParameters: GetPreferencesRequest): Promise<runtime.ApiResponse<UserPreferencesResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling getPreferences.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{userId}/preferences`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPreferencesResponseFromJSON(jsonValue));
    }

    /**
     * Get all user preferences for a specific user.
     * Get all user-preferences by userId
     */
    async getPreferences(requestParameters: GetPreferencesRequest): Promise<UserPreferencesResponse> {
        const response = await this.getPreferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update locale for a specific user.
     * Update locale by userId
     */
    async updateLocaleRaw(requestParameters: UpdateLocaleRequest): Promise<runtime.ApiResponse<UserPreferencesResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateLocale.');
        }

        if (requestParameters.updateUserLocaleRequest === null || requestParameters.updateUserLocaleRequest === undefined) {
            throw new runtime.RequiredError('updateUserLocaleRequest','Required parameter requestParameters.updateUserLocaleRequest was null or undefined when calling updateLocale.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{userId}/preferences/locale`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserLocaleRequestToJSON(requestParameters.updateUserLocaleRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPreferencesResponseFromJSON(jsonValue));
    }

    /**
     * Update locale for a specific user.
     * Update locale by userId
     */
    async updateLocale(requestParameters: UpdateLocaleRequest): Promise<UserPreferencesResponse> {
        const response = await this.updateLocaleRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update video-background for a specific user.
     * Update video-background by userId
     */
    async updateVideoBackgroundRaw(requestParameters: UpdateVideoBackgroundRequest): Promise<runtime.ApiResponse<UserPreferencesResponse>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling updateVideoBackground.');
        }

        if (requestParameters.updateUserVideoBackgroundRequest === null || requestParameters.updateUserVideoBackgroundRequest === undefined) {
            throw new runtime.RequiredError('updateUserVideoBackgroundRequest','Required parameter requestParameters.updateUserVideoBackgroundRequest was null or undefined when calling updateVideoBackground.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/users/{userId}/preferences/video-background`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserVideoBackgroundRequestToJSON(requestParameters.updateUserVideoBackgroundRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPreferencesResponseFromJSON(jsonValue));
    }

    /**
     * Update video-background for a specific user.
     * Update video-background by userId
     */
    async updateVideoBackground(requestParameters: UpdateVideoBackgroundRequest): Promise<UserPreferencesResponse> {
        const response = await this.updateVideoBackgroundRaw(requestParameters);
        return await response.value();
    }

}
